import { useState } from "react";
import { DOCUMENT_STATUSES, type CustomerDocumentInput } from "../../shared/customer-documents";
import { Field, FieldLabel } from "../components/ui/field";
import { Input } from "../components/ui/input";
import type { DocumentDraftProps } from "./CustomerDocumentSource";
export function CommercialFields({ value, onChange }: DocumentDraftProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {value.kind === "agreement" ? (
        <Field>
          <FieldLabel htmlFor="library-agreement-type">Agreement type</FieldLabel>
          <select
            id="library-agreement-type"
            className="customer-native-select"
            value={value.agreementType ?? "other"}
            onChange={(event) => {
              onChange({
                ...value,
                agreementType: event.target.value as CustomerDocumentInput["agreementType"],
              });
            }}
          >
            <option value="msa">Master services agreement</option>
            <option value="sow">Statement of work</option>
            <option value="nda">Nondisclosure agreement</option>
            <option value="other">Other agreement</option>
          </select>
        </Field>
      ) : null}
      <Field>
        <FieldLabel htmlFor="library-status">Status</FieldLabel>
        <select
          id="library-status"
          className="customer-native-select"
          value={value.status}
          onChange={(event) => {
            onChange({ ...value, status: event.target.value as CustomerDocumentInput["status"] });
          }}
        >
          {DOCUMENT_STATUSES[value.kind].map((status) => (
            <option key={status} value={status}>
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </option>
          ))}
        </select>
      </Field>
      <Field>
        <FieldLabel htmlFor="library-reference">
          Reference <span className="font-normal text-muted-foreground">optional</span>
        </FieldLabel>
        <Input
          id="library-reference"
          maxLength={80}
          value={value.reference ?? ""}
          onChange={(event) => {
            onChange({ ...value, reference: event.target.value || null });
          }}
        />
      </Field>
      <CommercialDates value={value} onChange={onChange} />
    </div>
  );
}

function CommercialDates({ value, onChange }: DocumentDraftProps) {
  const [amount, setAmount] = useState(() =>
    value.amountMinor === null ? "" : String(value.amountMinor / 100),
  );
  return (
    <>
      {" "}
      {value.kind === "quote" ? (
        <Field>
          <FieldLabel htmlFor="library-amount">Quote amount (USD)</FieldLabel>
          <Input
            id="library-amount"
            type="number"
            min="0"
            step="0.01"
            value={amount}
            onChange={(event) => {
              setAmount(event.target.value);
              onChange({
                ...value,
                amountMinor:
                  event.target.value === "" ? null : Math.round(Number(event.target.value) * 100),
              });
            }}
          />
        </Field>
      ) : null}
      <Field>
        <FieldLabel htmlFor="library-date">Document date</FieldLabel>
        <Input
          id="library-date"
          type="date"
          value={value.documentDate ?? ""}
          onChange={(event) => {
            onChange({ ...value, documentDate: event.target.value || null });
          }}
        />
      </Field>
      <Field>
        <FieldLabel htmlFor="library-expiry">
          Expires on <span className="font-normal text-muted-foreground">optional</span>
        </FieldLabel>
        <Input
          id="library-expiry"
          type="date"
          value={value.expiresOn ?? ""}
          onChange={(event) => {
            onChange({ ...value, expiresOn: event.target.value || null });
          }}
        />
      </Field>
    </>
  );
}
